export default __webpack_public_path__ + "static/media/evaluation_success.82789a16.png";